﻿export default class ReCaptcha {
    constructor(_elm) {
        this.elm = _elm;
        this.siteKey = $('body').data().recaptchasitekey;
        this.$elm = $(this.elm);
        this.$form = this.$elm.closest('form');
        this.args = this.$elm.data();
        this.widgetId = null;
        this.setEventListeners();

        // Delay against spam form submission
        this.timeOut = true;
        setTimeout(() => {
            this.timeOut = false;
        }, '5000');
    }

    validate(event) {
        event.preventDefault();
    }

    setEventListeners() {
        this.$form.on('submit', this.onFormValid.bind(this));
    }

    callback(token) {
        this.$form.find('[name="g-recaptcha-response"]').val(token);
        this.$form.trigger('submit', [true]);
    }

    onFormValid(event, skipRecaptcha = false) {
        

        if (skipRecaptcha) {
            return;
        }

        event.preventDefault();

        // Honeypot against spam
        if (!this.$form.find('[name="E-mail"]').val() && !this.timeOut) {
            if (this.widgetId === null) {
                this.widgetId = grecaptcha.render(this.elm, {
                    'sitekey': this.siteKey,
                    'callback': this.callback.bind(this)
                });
            }

            grecaptcha.execute(this.widgetId);
        }
    }

    onFormInValid(event) {
        //do nothing abide already shows why the form is not valid
    }
}